import Config from './Config';
import { Utilities } from '@microsoft/office-js-helpers';

export default class PortalIntegration {
    
    public static makeRequireLoginUrl(username: string, path: string) {
        var createAccountUrl = Config.getMarketingBaseUrl() + "/in-app/owa-create-account?username=" + encodeURIComponent(username);
        return Config.getWebPortalBaseUrl() + "/RequireLogin" + 
            "?username=" + encodeURIComponent(username) + 
            "&ReturnURL=" + encodeURIComponent(path) +
            "&createAccountUrl=" + encodeURIComponent(createAccountUrl);
    }

    public static makeEmbeddedPickupUrl(username: string, pickupId: string): string {
        var viewUrl = "/EmbeddedPickup/" + encodeURIComponent(pickupId);
        return PortalIntegration.makeRequireLoginUrl(username, viewUrl);
    }

    public static getUserAgentString(): string {
        var ptVersion = "Protected Trust Outlook Web Add-in/1.0.11.0 (dev)";

        var outlookVersion: string;
        if (Office.context.diagnostics) {
            outlookVersion = Office.context.diagnostics.host + "/" + Office.context.diagnostics.version + "-" + Office.context.diagnostics.platform;
        }
        else {
            // fall back to use hostInfoValue storage item
            let hostInfoValue = window.sessionStorage['hostInfoValue'] as string;

            let [hostRaw, platformRaw, extras] = hostInfoValue.split('$');

            // Older hosts used "|", so check for that as well:
            if (extras == null) {
                [hostRaw, platformRaw] = hostInfoValue.split('|');
            }

            outlookVersion = hostRaw + "/" + extras + "-" + platformRaw;
        }

        var userAgent = ptVersion + " " + outlookVersion;

        return userAgent;
    }
}


// WEBPACK FOOTER //
// ./src/D:/a/1/s/src/PortalIntegration.ts